import { sharedEnvironment } from './environment.shared';

export const environment = {
  production: true,
  BACKEND_HOST: '',
  ...sharedEnvironment
};
